import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Autocomplete, Box, Button, Checkbox, FormControlLabel, Step, StepLabel, Stepper, TextField, Typography } from "@mui/material";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import { AuthContext } from "context";
import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import MDAlert from "../../components/MDAlert";
import MDBox from "../../components/MDBox";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import apiService from "../../services/api-service";
import GenericForm from "../genericForm";
// GraphQL import removed - now using REST API

const steps = ["Dettagli Documento", "Campi Aggiuntivi"];

const GeneralDocumentAdd = () => {
	const authContext = useContext(AuthContext);
	const { id, areaName, idDocument } = useParams();
	const [activeStep, setActiveStep] = useState(0);
	const navigate = useNavigate();
	const [informationTypeOptions, setInformationTypeOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const [loadingDocument, setLoadingDocument] = useState(false);
	const [error, seterror] = useState("");
	const [formData, setFormData] = useState({
		name: "",
		has_expiration: false,
		category: "supplier",
		required: true,
		additional_fields: [],
		is_general: false,
	});

	const handleSetNotification = (msg, severityType) => {
		if (severityType === "success") {
			toast.success(msg, { id: "general-document-add-toast" });
		} else {
			toast.error(msg, { id: "general-document-add-toast" });
		}
	};

	const validateFormData = (data) => {
		// Funzione helper per verificare valori non validi
		const isInvalidValue = (value) => value === undefined || value === null || value === "";

		const checkValues = (obj) => {
			if (Array.isArray(obj)) {
				// Se è un array, verifica ogni elemento ricorsivamente
				return obj.every((item) => checkValues(item));
			} else if (typeof obj === "object" && obj !== null) {
				// Se è un oggetto, verifica i suoi valori ricorsivamente
				return Object.values(obj).every((value) => checkValues(value));
			}
			// Per i valori primitivi, verifica se sono invalidi
			return !isInvalidValue(obj);
		};

		// Verifica il formData principale
		return checkValues(data);
	};

	useEffect(() => {
		apiService
			.get("/information-types/", {}, {})
			.then((data) => {
				if (data) setInformationTypeOptions(data);
			})
			.catch((error) => {
				console.log(error);
				seterror(
					"Qualcosa è andato storto durante il caricamento delle tipologie di risposta. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #1214671000843"
				);
			});
	}, []);

	useEffect(() => {
		if (idDocument) {
			setLoadingDocument(true);
			apiService
				.get("/general-security-management/", { id_document: idDocument }, {})
				.then((data) => {
					setLoadingDocument(false);
					setFormData(data);
				})
				.catch((error) => {
					setLoadingDocument(false);
					seterror(
						"Qualcosaè andato storto durante il caricamento dei dati. Riprovaù tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #9986000843"
					);
				});
		}
	}, [idDocument]);

	useEffect(() => {
		if (activeStep === steps.length) {
			setLoading(true);
			if (!validateFormData(formData)) {
				handleSetNotification("Per favore compila ogni campo prima di proseguire", "warning");
				setActiveStep((prevActiveStep) => prevActiveStep - 1);
				setLoading(false);
				return;
			}
			apiService
				.post("/general-security-management/", {}, { ...formData, area_id: id })
				.then((data) => {
					setLoading(false);
				})
				.catch((error) =>
					seterror(
						"Qualcosa è andato storto durante la creazione del documento. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #127523671000843"
					)
				);
		}
	}, [activeStep]);

	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	const handleChange = (e) => {
		const { name, value, type, checked } = e.target;
		setFormData({
			...formData,
			[name]: type === "checkbox" ? checked : value,
		});
	};

	function handleAutocompleteChange(name, value) {
		if (value === null) {
			setFormData({
				...formData,
				[name]: null,
			});
			return;
		} else if (value === "supplier") {
			setFormData({
				...formData,
				[name]: value,
				["required"]: true,
			});
		} else {
			setFormData({
				...formData,
				[name]: value,
			});
		}
	}

	const categoryOptions = [
		{ label: "Utente", value: "user" },
		{ label: "Fornitore", value: "supplier" },
	];

	return (
		<DashboardLayout>
			{authContext.hasAuth("UPSERT_GENERAL_DOCUMENTS") ? (
				<>
					<Box sx={{ width: "100%", maxWidth: 900, margin: "auto", mt: 5 }}>
						<center>
							<Typography
								variant="h3"
								sx={{
									color: "#333",
									textTransform: "uppercase",
									fontWeight: "bold",
									letterSpacing: "1.5px",
									textAlign: "center",
									borderBottom: "2px solid #1A73E8",
									paddingBottom: "8px",
									marginBottom: "20px",
								}}
								gutterBottom
							>
								<span style={{ fontSize: "1.1rem" }}>
									{" "}
									{idDocument ? "MODIFICA DOCUMENTO GENERALE" : "AGGIUNGI UN DOCUMENTO GENERALE"}{" "}
								</span>
								<center>
									<Button
										onClick={() => navigate("/manage-general-document/")}
										variant="contained"
										sx={{
											backgroundColor: "#514f4f",
											color: "white!important",
											mb: 2,
											marginTop: 2,
											fontSize: "13px",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											gap: "8px",
											border: "1px solid #514f4f",
										}}
									>
										Torna alla tabella
									</Button>
								</center>
							</Typography>
						</center>
						{error !== "" ? (
							<Alert severity="error">{error}</Alert>
						) : (
							<>
								<Stepper activeStep={activeStep} alternativeLabel>
									{steps.map((label) => (
										<Step key={label}>
											<StepLabel>{label}</StepLabel>
										</Step>
									))}
								</Stepper>
								{loadingDocument ? (
									<center>
										<CircularProgress size={120} sx={{ marginTop: "25px", color: "#2b84ea" }} />
									</center>
								) : (
									<Box sx={{ mt: 4 }}>
										{activeStep === 0 && (
											<Box>
												<Typography variant="h6" gutterBottom>
													Dettagli Documento
												</Typography>
												<TextField
													fullWidth
													label="Nome del Documento"
													name="name"
													value={formData.name}
													onChange={handleChange}
													margin="normal"
												/>
												<FormControlLabel
													control={
														<Checkbox
															name="has_expiration"
															checked={formData.has_expiration}
															onChange={handleChange}
														/>
													}
													label="Il documento ha una scadenza?"
												/>
												<Autocomplete
													options={categoryOptions}
													getOptionLabel={(option) => option.label}
													value={categoryOptions.find((option) => option.value === formData.category) || null}
													onChange={(event, newValue) =>
														handleAutocompleteChange("category", newValue?.value || "")
													}
													renderInput={(params) => <TextField {...params} label="Categoria" margin="normal" />}
													fullWidth
												/>
												{formData.category === "user" && (
													<FormControlLabel
														control={
															<Checkbox name="required" checked={formData.required} onChange={handleChange} />
														}
														label="Il documento è da inserire per ogni operatore?"
													/>
												)}
											</Box>
										)}

										{activeStep === 1 && (
											<Box>
												<Typography variant="h6" gutterBottom>
													Campi Aggiuntivi
												</Typography>
												<GenericForm
													formData={formData}
													executeOnChangeTask={setFormData}
													executeOnChange={true}
													useSaveMethod={false}
													inputFields={[
														{
															type: "adder",
															name: "additional_fields",
															label: "Aggiungi campi aggiuntivi",
															fieldForEachInstance: [
																{ type: "text", name: "name", label: "Titolo del campo" },
																{
																	type: "autocomplete",
																	name: "information_type", // Nome nel DB
																	label: "Tipologia risposta", // Etichetta visibile
																	options: informationTypeOptions,
																	valueToDisplay: (value, options) => {
																		// Controlla se `value` è un oggetto
																		if (typeof value === "object") {
																			return `${value.name}` || "Tipologia non trovata"; // Mostra direttamente le informazioni
																		}
																		// Se `value` è un ID (numero)
																		const option = options.find((opt) => opt.id === value); // Cerca l'opzione in base all'ID
																		return option ? `${option.name}` : "Tipologia non trovata"; // Messaggio se non trovato
																	},
																	valueToSave: (selected) => {
																		// Se `selected` è un array
																		if (Array.isArray(selected)) {
																			// Crea un insieme di ID esistenti per evitare duplicati
																			const existingIds = new Set(
																				selected.map((opt) =>
																					typeof opt === "object" ? opt.id : opt
																				)
																			);

																			// Aggiungi il nuovo ID solo se non è già presente
																			return Array.from(existingIds);
																		}

																		// Se `selected` è un singolo oggetto, restituisci il suo ID
																		return selected;
																	},
																	valueComparator: (option, value) => {
																		// Controlla se `value` è un numero (ID)
																		if (typeof value === "number") {
																			return option.id === value; // Confronta l'ID dell'opzione con il valore
																		}

																		// Se `value` è un oggetto, confronta l'ID
																		return option.id === value.id; // Confronta l'ID dell'opzione con l'ID dell'oggetto value
																	},
																},
																{ type: "switch", name: "required", label: "Obbligatorio" }, // Campo opzionale
																{ type: "switch", name: "hidden", label: "Archivia" }, // Campo opzionale
															],
														},
													]}
												/>
											</Box>
										)}

										{activeStep < steps.length && (
											<Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
												<Button
													disabled={activeStep === 0}
													onClick={handleBack}
													variant="outlined"
													sx={{
														backgroundColor: "#514f4f",
														color: "white!important",
														mb: 2,
														fontSize: "16px",
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
														border: "1px solid #514f4f",
														gap: "8px",
														opacity: activeStep > 0 ? 0.95 : 0.1,
														transition: "all 0.3s ease", // Transizione per un effetto più fluido
														"&:hover": {
															backgroundColor: "#6b6969",
															opacity: 1,
															cursor: "pointer", // Aggiunge il puntatore a mano
														},
														"&:focus": {
															outline: "2px solid #ffffff",
															outlineOffset: "2px",
														},
														"&:active": {
															backgroundColor: "#3d3b3b",
															boxShadow: "inset 0 3px 5px rgba(0, 0, 0, 0.2)", // Effetto di pressione
														},
													}}
												>
													Indietro
												</Button>
												<Button
													onClick={handleNext}
													variant="contained"
													sx={{
														backgroundColor: "#514f4f",
														color: "white!important",
														mb: 2,
														fontSize: "16px",
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
														gap: "8px",
														border: "1px solid #514f4f",
													}}
												>
													{activeStep === steps.length - 1 ? "Conferma" : "Avanti"}
												</Button>
											</Box>
										)}

										{activeStep === steps.length && (
											<Box
												textAlign="center"
												sx={{
													backgroundColor: "#f5f5f5",
													padding: "20px",
													borderRadius: "8px",
													boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
												}}
											>
												{!loading ? (
													<>
														<Box
															display="flex"
															justifyContent="center"
															alignItems="center"
															sx={{ marginBottom: "10px" }}
														>
															<CheckCircleIcon
																sx={{
																	color: "green",
																	fontSize: "1.4em!important",
																	verticalAlign: "middle",
																	position: "relative",
																	top: "-3px",
																}}
															/>
															<Typography
																variant="h4"
																gutterBottom
																sx={{ color: "#1976d2", marginLeft: "8px", lineHeight: "40px" }}
															>
																Inserimento completato!
															</Typography>
														</Box>

														<Box sx={{ marginBottom: "15px", textAlign: "left" }}>
															<Typography variant="body1" sx={{ fontWeight: "bold" }}>
																Nome Documento:
															</Typography>
															<Typography variant="body1" sx={{ marginBottom: "10px" }}>
																{formData?.name}
															</Typography>
														</Box>
														<Box sx={{ marginBottom: "15px", textAlign: "left" }}>
															<Typography variant="body1" sx={{ fontWeight: "bold" }}>
																Ha Scadenza:
															</Typography>
															<Typography variant="body1" sx={{ marginBottom: "10px" }}>
																{formData?.has_expiration ? "Sì" : "No"}
															</Typography>
														</Box>
														<Box sx={{ marginBottom: "15px", textAlign: "left" }}>
															<Typography variant="body1" sx={{ fontWeight: "bold" }}>
																Categoria:
															</Typography>
															<Typography variant="body1" sx={{ marginBottom: "10px" }}>
																{formData?.category === "supplier" ? "Fornitore" : "Operatore"}
															</Typography>
														</Box>
														{formData?.category === "user" && (
															<Box sx={{ marginBottom: "15px", textAlign: "left" }}>
																<Typography variant="body1" sx={{ fontWeight: "bold" }}>
																	Necessario per ogni Operatore:
																</Typography>
																{/*<Typography variant="body1" sx={{marginBottom: '10px'}}>
                                            {formData?.required ? 'Si' : 'No'}
                                          </Typography>*/}
															</Box>
														)}
														<Box sx={{ textAlign: "left" }}>
															<Typography variant="body1" sx={{ fontWeight: "bold", marginBottom: "5px" }}>
																Campi Aggiuntivi:
															</Typography>
															{formData?.additional_fields.map((field) => (
																<Box
																	key={field.name}
																	sx={{
																		padding: "8px",
																		marginBottom: "5px",
																		borderRadius: "6px",
																		backgroundColor: "#ffffff",
																		boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
																	}}
																>
																	<Typography variant="body2">
																		<b>Titolo del campo:</b> {field?.name}
																	</Typography>
																	<Typography variant="body2">{field?.information_type?.name}</Typography>
																	{/*<Typography variant="body2">
                                            {field?.required ? 'Obbligatorio' : 'Opzionale'}
                                          </Typography>*/}
																</Box>
															))}
															<Box
																sx={{
																	display: "flex",
																	justifyContent: "space-between",
																	marginTop: "20px",
																	alignItems: "center",
																	flexDirection: "row",
																}}
															>
																<Button
																	onClick={() => navigate("/manage-general-document/")}
																	variant="contained"
																	sx={{
																		backgroundColor: "#514f4f",
																		color: "white!important",
																		mb: 2,
																		fontSize: "10px",
																		display: "flex",
																		alignItems: "center",
																		justifyContent: "center",
																		gap: "8px",
																		border: "1px solid #514f4f",
																	}}
																>
																	Vedi documenti <br />
																	generale
																</Button>
																<Button
																	onClick={() => {
																		const newUrl = `/general-document-add/`;
																		window.location.href = newUrl; // Ricarica la pagina
																	}}
																	variant="contained"
																	sx={{
																		backgroundColor: "#514f4f",
																		color: "white!important",
																		mb: 2,
																		fontSize: "10px",
																		display: "flex",
																		alignItems: "center",
																		justifyContent: "center",
																		gap: "8px",
																		border: "1px solid #514f4f",
																	}}
																>
																	Nuovo documento
																	<br />
																	generale
																</Button>
															</Box>
														</Box>
													</>
												) : (
													<CircularProgress size={120} sx={{ marginTop: "25px", color: "#2b84ea" }} />
												)}
											</Box>
										)}
									</Box>
								)}
							</>
						)}
					</Box>
				</>
			) : (
				<MDBox mt={8}>
					<MDAlert color="error">Non hai i permessi per visualizzare questa pagina</MDAlert>
				</MDBox>
			)}
		</DashboardLayout>
	);
};

export default GeneralDocumentAdd;
